import React from "react";
import './AddWrapper.css';
const AppWrapper = () => {
  return (
    <div className="appWrapper">
      <div className="container-size flex justify-center">
      <div className="appWrapper-content">
        <h3 className="wrapper-title">Download our app</h3>

        <div className="wrapper-subtitle">A world market in your hand</div>
        <p>
          Credibly pursue go forward meta-services rather than high-payoff best
          practices.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-4">
           
           <button className="wrapper-button ">
           <i className="uil uil-android text-2xl mr-2"></i> Download
           </button>
           
          
          <button className="wrapper-button my-5 lg:my-0">
            <i className="uil uil-apple text-2xl mr-2"></i> Download
          </button>
          <button className="wrapper-button mt-4 lg:mt-0">
            <i className="uil uil-windows text-2xl mr-2"></i> Download
          </button>
        </div>
      </div>
      </div>
    </div>
  );
};

export default AppWrapper;
